export const residence = 'https://vim.azureedge.net/samples/residence.v1.2.75.vim'

// Ask Martin or Simon for the access token
export const residenceWithAccessToken = 'https://saas-api-v2.vimaec.com/api/public/542c2335-992d-4af0-ffd9-08dd0262dd9c/2024-11-11T15:09:43'

export const support = 'https://docs.vimaec.com'
export const supportControls = 'https://docs.vimaec.com/docs/vim-cloud/webgl-navigation-and-controls-guide'

export const notAVim = 'https://vimdevelopment01storage.blob.core.windows.net/samples/not_a_vim.vim'

export const medicalTower = 'https://vim.azureedge.net/samples/Medical_Tower.vim'
